import { MaterialIconName } from '@gorila-shared-ui/components';

export const SAFE_SPOT_TYPES: {
  [key: string]: {
    title: string;
    icon: MaterialIconName;
  };
} = {
  '1': { title: 'Hoteles', icon: 'hotel' },
  '2': { title: 'Talleres', icon: 'handyman' },
  '3': { title: 'Gasolineras', icon: 'local_gas_station' },
};

export const UNSAFE_SPOT_TYPE: {
  [key: string]: {
    title: string;
    icon: MaterialIconName;
  };
} = {
  '4': { title: 'Deshuesaderos', icon: 'car_repair' },
};

export const SPOT_TYPE_IDS = Object.keys({ ...SAFE_SPOT_TYPES, ...UNSAFE_SPOT_TYPE });

export const SAFE_SPOTS = Object.values(SAFE_SPOT_TYPES);
export const UNSAFE_SPOTS = Object.values(UNSAFE_SPOT_TYPE);
